import firebase from "services/FirebaseService";
import { dispatch } from "whiteboard/AppStore";
import forIn from "lodash/forIn";
import shortid from "shortid";
import { arrayMove } from "react-sortable-hoc";

const db = firebase.firestore();

const addDataMod = firebase.functions().httpsCallable("addDataMod");
const updateDataMod = firebase.functions().httpsCallable("updateDataMod");

const blankMod = {
  type: "Blank"
};

function getBlankMod() {
  return { ...blankMod, id: shortid.generate() };
}

const defaultState = {
  modid: shortid.generate(),
  name: "My Pocketmod",
  desc: "",
  pageIndex: 0, // editor page index
  pages: [getBlankMod(), getBlankMod(), getBlankMod(), getBlankMod(), getBlankMod(), getBlankMod(), getBlankMod(), getBlankMod()]
};

const model = {
  state: defaultState,
  reducers: {
    insertModIntoEditorPage(state, mod) {
      const newMod = JSON.parse(JSON.stringify(mod));
      newMod.id = shortid.generate();
      let pages = state.pages.slice();
      pages[state.pageIndex] = newMod;
      return { ...state, pages };
    },
    onChangeModData(state, data) {
      const newMod = JSON.parse(JSON.stringify(state.pages[state.pageIndex]));
      let pages = state.pages.slice();
      forIn(data, (val, key) => {
        newMod.options[key].value = val;
      });
      pages[state.pageIndex] = newMod;
      return { ...state, pages };
    },
    onChangeModDesignerText(state, { item, index, doc }) {
      const page = state.pages[state.pageIndex];
      const value = page.options.items.value.map(element => {
        if (!element.id || element.id === item.id) {
          return { ...element, value: doc.value };
        }
        return element;
      });
      const newState = { ...state };
      newState.pages[state.pageIndex].options.items.value = value;
      return newState;
    },
    onChangeModDesignerPosition(state, { item, index, obj }) {
      const page = state.pages[state.pageIndex];
      const value = page.options.items.value.map(element => {
        if (!element.id || element.id === item.id) {
          let position = { ...element.position, ...obj };
          return { ...element, position };
        }
        return element;
      });
      const newState = { ...state };
      newState.pages[state.pageIndex].options.items.value = value;
      return newState;
    },
    setModData(state, book) {
      return { ...state, ...book };
    },
    setSelectedPageToFocus(state, pageIndex) {
      return { ...state, pageIndex };
    },
    onChangeModPosition(state, { oldIndex, newIndex }) {
      const pages = arrayMove(state.pages, oldIndex, newIndex);
      return { ...state, pages, pageIndex: newIndex };
    },
    newEmptyMod(state, pageIndex) {
      return { ...state, ...defaultState };
    }
  },
  effects: {
    async loadMod({ modId, onFailToLoad, loadFromTemp }, rootState) {
      if (!modId) {
        return;
      }
      const collectionName = loadFromTemp ? "temp-data-mods" : "data-mods";
      try {
        const doc = await db
          .collection(collectionName)
          .doc(modId)
          .get();
        if (!doc.exists) {
          return onFailToLoad();
        }
        // exists!
        const mod = doc.data();
        this.setModData(mod.book);
      } catch (e) {
        console.log("Error getting document:", e);
        onFailToLoad();
      }
    },
    async savePocketmod({ modId, onSuccess, name, desc }, rootState) {
      const shouldCreate = !modId || name !== rootState.editor.name
      this.setModData({ name, desc });
      const book = { ...rootState.editor, name, desc };
      if (shouldCreate) {
        // create a mod
        try {
          book.modId = undefined;
          const result = await addDataMod({ book });
          onSuccess(result.data.id);
        } catch (e) {
          console.error(e);
          alert(e.message);
        }
      } else {
        // update mod
        try {
          const result = await updateDataMod({ book, modId });
          onSuccess(result.data.id);
        } catch (e) {
          console.error(e);
          alert(e.message);
        }
      }
    }
  }
};

export default model;



// WEBPACK FOOTER //
// ./src/whiteboard/models/editor.js